/**
 * User structure
 * {
    name: 'state for login user',
    desc: 'platform description',
    application_id: 1,
    authedActions: [],
    account: null,
    session: null,
    accountPwd: null,
    lastLoginTime: 0
  }
 */
export default {
  data () {
    return {
      willRemoved: new Set()
    }
  },
  methods: {
    changeCheckbox (event, type, val) {
      switch (type) {
        case 0:
          {
            let all = window.$('input[name="check-item"]')
            if (event.target.checked) {
              all.each((i, elem) => {
                this.willRemoved.add(+elem.id)
                elem.checked = true
              })
            } else {
              this.willRemoved.clear()
              all.each((i, elem) => {
                elem.checked = false
              })
            }
            break
          }
        case 1:
          {
            if (event.target.checked) {
              this.willRemoved.add(+val)
            } else {
              this.willRemoved.delete(+val)
            }
          }
      }
    },
    uncheckAll () {
      window.$('input[name="check-item"]').prop('checked', false)
      window.$('input[name="check-title"]').prop('checked', false)
      this.willRemoved.clear()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/table-checkbox.js